import request from "@/utils/keyCloakRequest";

/**
 * 从详情接口数据同步审批人姓名（优先使用审批记录回填的 item 字段）
 */
export function syncAppReviewerNames(vm, item) {
  if (!item) {
    return;
  }
  if (item.managerName) {
    vm.managerName = item.managerName;
  }
  if (item.fgldName) {
    vm.fgldName = item.fgldName;
  }
  if (item.officeName) {
    vm.officeName = item.officeName;
  }
}

/**
 * App 详情是否隐藏部门负责人行（与 PC isManage 一致）
 * showManager=1 展示部门负责人；isManage=true 表示隐藏
 */
export function resolveAppIsManage(vm, item, processId) {
  const pid = processId || (item && item.processId) || (vm && vm.processId);
  if (item && item.showManager != null && item.showManager !== undefined) {
    vm.isManage = item.showManager !== 1;
    return Promise.resolve();
  }
  return request({
    url:
      "appFindMamangeId?userId=" +
      item.userId +
      (pid ? "&processId=" + pid : ""),
    method: "get",
  }).then((response) => {
    vm.isManage = String(item.userId) === String(response);
  });
}
